import {FILTER_ALL, FILTER_CUSTOM, FILTER_NONE} from './filters';

export default [
  {key: FILTER_ALL, label: 'Alle Datens.'},
  {key: FILTER_CUSTOM, label: 'gefiltert (Datens.)'},
  {key: FILTER_NONE, label: 'Keine Datens.'},
];
